// import { isEmpty } from 'lodash'
import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {}

const getActions = generateActions('checkout/GET')

export const get = createAction(
  API_CONST,
  (id = null) => ({
    actions: getActions,
    url: `checkout/${id}`
  })
)

export default handleActions({
  [getActions[1]]: (state, { payload }) => ({
    ...state,
    checkout: payload
  }),
  [getActions[2]]: (state, { payload }) => ({
    ...state,
    init: true
  })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/checkout/index.js